import firebase from 'firebase/compat/app'; //using firebase version 9.12.1
import 'firebase/compat/messaging';
import {getMessaging, getToken, onMessage} from 'firebase/messaging';
import { call, put, takeEvery, select} from "redux-saga/effects";
import axios from "axios";
import { url } from 'APIs/URLS';




const firebaseConfig = {
    apiKey: "AIzaSyCSer4H1VaRvB-qxXyiwA2JBSNds_PwDKE",
    authDomain: "digilab-f1549.firebaseapp.com",
    projectId: "digilab-f1549",
    storageBucket: "digilab-f1549.appspot.com",
    messagingSenderId: "561426913260",
    appId: "1:561426913260:web:f15df6decf9596be6712c9"
  };

const app=firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging(app);
// const analytics = getAnalytics(app);


export const Token = async (User) => {
    try {
        const currentToken = await getToken(messaging, { vapidKey: 'BJ6svnWkMddFqduSsw57xRPf6MNeS_hNGpfTUQNKvcqc04AtvLAaMSg-vpY3zj6q1ZTXu-wak2AXWUQeiDMHRGo' });
        if (currentToken) {
            console.log('current token for client: ', currentToken);
            SendTokenToServer(currentToken,User);
        } else {
            console.log('No registration token available. Request permission to generate one.');
            // this.setState({ isTokenFound: false });
            // isTokenFound(false);
        }
    } catch (err) {
        console.log('An error occurred while retrieving token. ', err);
    }
  }

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});


export const SendTokenToServer = async (currentToken, User) => {
   var token = User.refresh_token;
   console.log("token in send token to server", token);
  try {
    const response = await axios.post(`${url}/devices`, {
      registration_id: currentToken,
      user: User.email,
      type: 'web'
    }, {
      headers: {
         "content-type": "application/json",
          Authorization: `Bearer  ${token}`,
      }
    });
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};